import { cn } from "../../lib/utils";

export function SkipLink() {
  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50",
        "bg-brand-primary text-white px-4 py-2 rounded-md shadow-lg font-medium",
        "transition-transform duration-200"
      )}
    >
      Vai al contenuto principale
    </a>
  );
}
